module.exports = __webpack_public_path__ + "static/img/icon_user_headimg.02007e46.png";